module.exports = __webpack_public_path__ + "static/media/wurlitzerCd02.60b64c5e.jpg";